import {MarkerClusterer} from "@googlemaps/markerclusterer";

window.initMap = initMap;

export async function initMap() {

  const {Map} = await google.maps.importLibrary("maps");
  const {AdvancedMarkerElement, PinElement} = await google.maps.importLibrary(
    "marker",
  );


  $('.flixx_network').each(function () {

    let
      $map = $('.map', this),
      $table = $('table', this),
      markers = [],
      map = new google.maps.Map($map[0], {
        center: {lat: 44.590467, lng: 1.222503},
        zoom: 2,
        mapId: '5eb1423287e4adc6',
        disableDefaultUI: true, // a way to quickly hide all controls
        //mapTypeControl: false,
        //scaleControl: false,
        zoomControl: true,
      }),
      pinOptionsWhite = {
        glyphColor: "#0080AC",
        background: "#e5f2f7",
        borderColor: "#0080AC",
      },
      pinOptionsBlue = {
        glyphColor: "#0080AC",
        background: "#44a6c7",
        borderColor: "#0080AC",
      },
      clusterOptions = {
        render: ({count, position}) =>
          new google.maps.Marker({
            position,
            label: {text: markers.length, color: "blue", fontSize: "14px"},
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          }),
      };

    let activeInfoWindow = null;

    $table.find('tbody tr:not(.d-none)').each(function () {


      let company = {
        id: parseInt($(this).attr('data-id')),
        flag: parseInt($(this).attr('data-flag')),
        lat: parseFloat($(this).attr('data-lat')),
        lng: parseFloat($(this).attr('data-lng')),
        name: $('td:nth-child(1)', this).html(),
        address: $('td:nth-child(2) > p', this).html(),
        country: $('td:nth-child(3)', this).html(),
        contact: $('td:nth-child(4) > p', this).html()
      };

      let companyPin = null;

      // Change the background color for each pin
      if(company.flag === 1){
        companyPin = new PinElement(pinOptionsBlue);
      }else{
        companyPin = new PinElement(pinOptionsWhite);
      }

      let marker = new AdvancedMarkerElement({
        //let marker = new google.maps.Marker({
        map,
        position: {lat: company.lat, lng: company.lng},
        title: company.name,
        content: companyPin.element,
      });

      // Push single markers to markers array - necessary for clustering
      markers.push(marker);

      // Build the info-box html
      let infoboxHtml =
        '<div class="content">' +
        '<h3>' + company.name + '</h3>' +
        '<p>' +company.address + '<br>' + company.country + '</p>' +
        '<p>' + company.contact + '</p>' +
        '</div>';

      // Add the info-box to the current marker
      let infobox = new google.maps.InfoWindow({
        content: infoboxHtml,
        ariaLabel: company.name,
      });

      // Add an event to open the info-box
      marker.addListener("click", () => {
        if (activeInfoWindow) {
          activeInfoWindow.close();
        }
        infobox.open({
          anchor: marker,
          map,
        });
        activeInfoWindow = infobox;
      });

    });


    let renderer = {
      render({ count, position }, stats) {
        const svg = window.btoa(`
        <svg fill="#0080AC" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <circle cx="120" cy="120" opacity=".6" r="70" /></svg>`);
        return new google.maps.Marker({
          position,
          label: {
            text: String(count),
            color: "#ffffff",
            fontSize: "12px",
          },
          icon: {
            url: `data:image/svg+xml;base64,${svg}`,
            scaledSize: new google.maps.Size(45, 45),
          },
          title: String(count),
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        });
      }
    }


    // Add a marker clusterer to manage the markers.
    new MarkerClusterer({markers, map, renderer});

  });

}
